import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://gruauibzjkzzawdsmyve.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdydWF1aWJ6amt6emF3ZHNteXZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTgzNjkyNTYsImV4cCI6MjAzMzk0NTI1Nn0.S_HojCDJzVAC3MNpSeb244sOoi8JMoiGNkMXeodwXDo";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
